// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-x: hidden;
}

/* Show mobile menu toggle only on mobile; hide on desktop */
.mob-menu {
  display: none;
}

.mob-hide {
  display: block;
}

@media (max-width: 955px) {
  .mob-menu {
    display: block;
  }
}
.dashbored-wrap {
  width: 100%;
  height: 100vh;
  background: var(--fc-bg, #fff);
}
.dashbored-wrap .logo {
  width: 100px;
  margin-right: 100px;
}
.dashbored-wrap .top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}
.dashbored-wrap .user-name {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.dashbored-wrap .user-name p {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.dashbored-wrap .top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}
.dashbored-wrap .dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}
.dashbored-wrap .detail-list {
  max-width: 250px;
  width: 100%;
  padding: 20px 10px;
  background-color: #efeeee;
  color: #212529;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 120px);
}
.dashbored-wrap ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.dashbored-wrap p {
  margin-bottom: 10px;
}
.dashbored-wrap ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}
.dashbored-wrap ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}
.dashbored-wrap ul li:hover {
  color: #000;
}
.dashbored-wrap ul li:hover:before {
  /* background: #fff;
  color: #212529; */
  width: 100%;
}
.dashbored-wrap .table-bordered {
  border: 0px;
}
.dashbored-wrap .detail-description {
  width: 100%;
  height: 100%;
  padding: 0px;
  position: absolute;
  /* background: purple; */
}
.dashbored-wrap .followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}
.dashbored-wrap h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}
.dashbored-wrap .com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.dashbored-wrap .com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}
.dashbored-wrap .com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
  background: #5ea1d8;
}
.dashbored-wrap .ico-box {
  width: 40px;
  height: 40px;
  background: #efeeee;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0px;
  position: absolute;
  top: calc(var(--app-header) + 54px);
  width: calc(100% - 30px);
  width: 100%;
  left: 0px;
  /* width:calc(100% - 76px); */
}
.dashbored-wrap .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}
.dashbored-wrap .filter-ico li {
  width: 40px;
}
.dashbored-wrap .filter-ico li i {
  color: #000;
}
.dashbored-wrap .text {
  padding-right: 10px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
  overflow-y: auto;
}
.dashbored-wrap table {
  margin-bottom: 20px;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.dashbored-wrap th,
.dashbored-wrap td {
  border: none;
  color: #000;
  padding: 16px;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: middle;
}
.dashbored-wrap th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e0e0e0;
}
.dashbored-wrap td {
  border-bottom: 1px solid #e0e0e0;
}
.dashbored-wrap td[scope=row] {
  position: relative;
}
.dashbored-wrap .inner {
  width: 100%;
  margin-bottom: 0px;
}
.dashbored-wrap .inner td {
  padding: 5px;
  border: 0px;
}
.dashbored-wrap .inner td:first-child {
  width: 30px;
}
.dashbored-wrap tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.dashbored-wrap tbody tr:hover {
  background-color: #f9f9f9;
}
.dashbored-wrap tbody tr:hover td {
  color: #000;
}
.dashbored-wrap tbody tr:last-child td {
  border-bottom: none;
}
.dashbored-wrap tbody tr span {
  display: flex;
  align-items: center;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}
.dashbored-wrap .filter-title {
  flex: 1;
}
.dashbored-wrap .filter ul {
  display: flex;
  float: right;
}
.dashbored-wrap .filter-bar {
  display: flex;
  width: 100%;
}
.dashbored-wrap .filter-ico {
  flex: 1;
}
.dashbored-wrap .search-container {
  position: relative;
}
.dashbored-wrap .search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}
.dashbored-wrap .search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}
.dashbored-wrap .search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.dashbored-wrap .chekbox-image {
  display: flex;
}
.dashbored-wrap .chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .chekbox-image td:first-child span {
  padding-left: 13px;
}
.dashbored-wrap .chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .image-sec img {
  max-width: 100%;
  max-height: 80px;
  object-fit: cover;
}
.dashbored-wrap .mobile-design {
  display: none;
}

@media (max-width: 992px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 15px;
  }
  .dashbored-wrap .com-record:after {
    height: 130px;
  }
  .dashbored-wrap .search-container .search-input {
    width: 100%;
  }
  .dashbored-wrap .top-menu-wrap {
    display: none;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: none;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .dashbored-wrap .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .dashbored-wrap .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .dashbored-wrap .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .dashbored-wrap .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .dashbored-wrap .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .dashbored-wrap .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .dashbored-wrap .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .dashbored-wrap .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .dashbored-wrap .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .dashbored-wrap .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .dashbored-wrap .mobile-design .common-tile {
    display: flex;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  height: 13vh;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  height: 100vh;
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  padding-left: 10px;
  margin-top: 0; /* remove global top gap under header */
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/* In your component CSS */
li.active {
  background: #1d67a3 !important;
  padding-left: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  top: var(--app-header); /* align to global header height */
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* align just below app header - match landing page */
  margin-top: 0 !important; /* avoid extra collapse/push inside components */
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

.setting-dashboard .show-menu .left-user {
  left: 0px;
  transition: left 0.5s linear;
}

/*panel collapse */
.toggle-settings-class .left-user {
  width: 80px;
}
.toggle-settings-class .left-user .dash-title {
  font-size: 0px;
}
.toggle-settings-class .left-user .dash-title h6 span {
  margin-right: 0px;
}
.toggle-settings-class .left-user .dash-title h6 span:last-child {
  display: none;
}
.toggle-settings-class .left-user .search input {
  display: none;
}
.toggle-settings-class .left-user .search i {
  color: #fff;
}
.toggle-settings-class .left-user .dash-elemenet div span:last-child {
  display: none;
}
.toggle-settings-class .submission-field {
  left: 80px;
  width: calc(100% - 80px);
}
.toggle-settings-class .submission-field .hamburger .dash-title {
  left: 80px;
  width: calc(100% - 80px);
}
.toggle-settings-class .collapse-btn {
  transform: none !important;
}
.toggle-settings-class .pagination-wrap {
  left: 80px;
  width: calc(100% - 80px);
}
.toggle-settings-class .graybg {
  display: block;
}
.toggle-settings-class .graybg div {
  white-space: nowrap;
  padding: 0px 5px 0px 8px !important;
}
.toggle-settings-class .graybg div span {
  overflow: hidden;
  display: block !important;
  margin-right: 0px !important;
  letter-spacing: 15px;
}
.toggle-settings-class .graybg div span::first-letter {
  display: block;
  white-space: nowrap;
  font-size: 20px;
}

.toggle-settings-class .pagination-wrap {
  width: calc(100% - 80px) !important;
}

/* ===========================================
   MOBILE MENU - MATCHES DESKTOP MENU STYLING
   =========================================== */
@media (max-width: 767px) {
  /* Hamburger button */
  .mob-menu {
    background: #5d9fd5;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1999;
    width: 100%;
    display: block;
  }
  /* Hide hamburger button when menu is open */
  .setting-dashboard.show-menu .mob-menu {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    z-index: 1 !important;
  }
  .navbar {
    justify-content: flex-end;
    margin-bottom: 0;
    padding: 0;
  }
  .mob-menu button {
    background: #5d9fd5;
    color: #fff;
    font-size: 14px;
    padding: 12px 20px;
    border: 1px solid #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    margin-right: 15px;
    cursor: pointer;
  }
  /* Mobile Menu Overlay */
  .setting-dashboard.show-menu::after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1998;
    display: block;
  }
  /* Override mob-hide to show menu when opened */
  .setting-dashboard.show-menu .mob-hide .left-user {
    display: block !important;
  }
  /* Mobile Menu Panel - Slides from right, same structure as desktop */
  .setting-dashboard .left-user {
    position: fixed !important;
    top: 0;
    left: auto !important;
    right: -100%;
    width: 280px;
    max-width: 85vw;
    height: 100vh;
    background: #5ea1d8;
    z-index: 2001 !important;
    transition: right 0.3s ease-in-out;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 0 0 30px;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .setting-dashboard.show-menu .left-user {
    left: auto !important;
    right: 0 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    z-index: 2001 !important;
  }
  /* Show desktop title in mobile (same as desktop) */
  .setting-dashboard .left-user .dash-title {
    display: flex;
    position: relative;
    width: 100%;
    height: 80px;
    align-items: center;
    padding: 0;
    margin: 0;
    top: 0;
    z-index: 2;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  /* Menu Content Container - Same as desktop */
  .setting-dashboard .left-user .dash-elemenet {
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    margin-top: 1rem;
    height: calc(100vh - 220px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 20px;
    width: 100%;
    visibility: visible !important;
    opacity: 1 !important;
  }
  /* Menu List Container - Same as desktop */
  .setting-dashboard .left-user .detail-list {
    display: block !important;
    width: 100%;
    max-width: 250px;
    padding: 20px 10px;
    background-color: transparent;
    position: relative;
    height: auto;
    visibility: visible !important;
    opacity: 1 !important;
  }
  /* Menu List - Same as desktop */
  .setting-dashboard .left-user ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  /* Menu List Items - Same styling as desktop */
  .setting-dashboard .left-user ul li {
    height: 40px;
    margin-bottom: 10px;
    position: relative;
    display: flex !important;
    align-items: center;
    transition: all 0.5s linear;
    padding-left: 10px;
    color: #fff !important;
    font-size: 13px;
    font-weight: 400;
    cursor: pointer;
    background: transparent;
    visibility: visible !important;
    opacity: 1 !important;
  }
  /* Hover effect - Same as desktop */
  .setting-dashboard .left-user ul li:after {
    bottom: 0;
    content: "";
    display: block;
    height: 100%;
    left: 0%;
    position: absolute;
    background: #1d67a3;
    transition: all 0.5s linear;
    width: 0;
    z-index: -1;
  }
  .setting-dashboard .left-user ul li:hover:after,
  .setting-dashboard .left-user ul li:active:after,
  .setting-dashboard .left-user ul li:focus:after {
    content: "";
    width: 100%;
    left: 0;
    transition: all 0.5s linear;
  }
  /* Active state - Same as desktop */
  .setting-dashboard .left-user ul li.active {
    background: #1d67a3 !important;
    color: #fff !important;
    padding-left: 10px;
  }
  .setting-dashboard .left-user ul li.active:after {
    width: 100%;
  }
  /* Content Area Adjustments */
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0;
    position: relative;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    position: relative;
    top: 0;
    height: auto;
    padding: 15px;
  }
  /* Ensure router-outlet content doesn't interfere with menu */
  router-outlet {
    display: block;
    width: 100%;
  }
  /* Ensure menu works on all child pages */
  .setting-dashboard router-outlet ~ *,
  .setting-dashboard router-outlet + * {
    position: relative;
    z-index: 1;
  }
  /* When menu is open, ensure child page content is behind menu */
  .setting-dashboard.show-menu router-outlet ~ *,
  .setting-dashboard.show-menu router-outlet + * {
    z-index: 1;
  }
  /* Remove all padding and margin from child pages on mobile */
  router-outlet ~ *,
  router-outlet + * {
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * *,
  router-outlet + * * {
    margin-top: 0 !important;
  }
  router-outlet ~ * .dashbored-wrap,
  router-outlet + * .dashbored-wrap {
    margin-top: 10px !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * .scroll-div,
  router-outlet + * .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  router-outlet ~ * .com-record,
  router-outlet + * .com-record {
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * .table-wrap,
  router-outlet + * .table-wrap {
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * .mobile-design,
  router-outlet + * .mobile-design {
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * .detail-description,
  router-outlet + * .detail-description {
    padding: 0 !important;
    margin: 0 !important;
  }
  router-outlet ~ * .hamburger,
  router-outlet + * .hamburger {
    margin: 0 !important;
    padding: 0 !important;
  }
  router-outlet ~ * .submission-field,
  router-outlet + * .submission-field {
    padding: 0 !important;
    margin: 0 !important;
  }
  /* Specifically target scroll-div in all user-dashboard child pages on mobile */
  app-dashboard .scroll-div,
  app-content-analytics .scroll-div,
  app-giftedfunds .scroll-div,
  app-consultations .scroll-div,
  app-scheduleconsultations .scroll-div,
  app-access-requests .scroll-div,
  app-transfered-content-approvals .scroll-div,
  app-outgoing-approvals .scroll-div,
  app-incoming-approvals .scroll-div,
  app-content-approvals .scroll-div,
  app-flow-reviews .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .table-wrap {
    padding: 0;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px; /* match landing page mobile padding */
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
}
@media (min-width: 1920px) {
  .dashbored-wrap .detail-list {
    max-width: 300px;
    padding: 30px 20px;
  }
  .dashbored-wrap .detail-description {
    margin-left: 320px;
    padding: 30px;
  }
  .dashbored-wrap .followers-tag .box {
    padding: 25px;
    font-size: 16px;
  }
}
@media (min-width: 1440px) and (max-width: 1920px) {
  .dashbored-wrap .detail-list {
    max-width: 280px;
    padding: 25px 15px;
  }
  .dashbored-wrap .detail-description {
    margin-left: 300px;
    padding: 25px;
  }
}
@media (min-width: 1200px) and (max-width: 1440px) {
  .dashbored-wrap .detail-list {
    max-width: 250px;
  }
  .dashbored-wrap .detail-description {
    margin-left: 270px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .dashbored-wrap .detail-list {
    max-width: 220px;
    padding: 15px 10px;
  }
  .dashbored-wrap .detail-description {
    margin-left: 240px;
    padding: 20px;
  }
  .dashbored-wrap .followers-tag .box {
    width: calc(50% - 10px);
    min-width: 200px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (min-width: 768px) and (max-width: 1024px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    margin-left: 0;
    padding: 20px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
    gap: 15px;
  }
  .dashbored-wrap .followers-tag .box {
    width: calc(50% - 7.5px);
    min-width: 200px;
    padding: 15px;
  }
  .dashbored-wrap .top-menu-wrap {
    padding: 15px 10px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .user-details {
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (min-width: 480px) and (max-width: 768px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    margin-left: 0;
    padding: 15px;
  }
  .dashbored-wrap .followers-tag {
    flex-direction: column;
    gap: 12px;
  }
  .dashbored-wrap .followers-tag .box {
    width: 100%;
    min-width: unset;
    padding: 12px;
  }
  .dashbored-wrap .followers-tag .box .text {
    font-size: 14px;
  }
  .dashbored-wrap .top-menu-wrap {
    padding: 10px;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    height: auto;
    min-height: 80px;
  }
  .dashbored-wrap .user-details {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }
  .dashbored-wrap .hamburger {
    display: block;
  }
  .dashbored-wrap .hamburger .dash-title h6 {
    font-size: 16px;
    margin: 0;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (max-width: 480px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    margin-left: 0;
    padding: 10px;
  }
  .dashbored-wrap .followers-tag {
    flex-direction: column;
    gap: 10px;
  }
  .dashbored-wrap .followers-tag .box {
    width: 100%;
    min-width: unset;
    padding: 10px;
  }
  .dashbored-wrap .followers-tag .box .text {
    font-size: 13px;
  }
  .dashbored-wrap .followers-tag .box .icon .ico-box {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
  .dashbored-wrap .top-menu-wrap {
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    height: auto;
    min-height: 70px;
  }
  .dashbored-wrap .user-details {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }
  .dashbored-wrap .user-details .user-name p {
    font-size: 14px;
  }
  .dashbored-wrap .user-details .user-name span {
    width: 30px;
    height: 30px;
  }
  .dashbored-wrap .hamburger {
    display: block;
  }
  .dashbored-wrap .hamburger .dash-title h6 {
    font-size: 14px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .dashbored-wrap .hamburger .dash-title h6 .material-icons {
    font-size: 18px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (max-width: 320px) {
  .dashbored-wrap .detail-description {
    padding: 8px;
  }
  .dashbored-wrap .followers-tag {
    gap: 8px;
  }
  .dashbored-wrap .followers-tag .box {
    padding: 8px;
  }
  .dashbored-wrap .followers-tag .box .text {
    font-size: 12px;
  }
  .dashbored-wrap .followers-tag .box .icon .ico-box {
    width: 25px;
    height: 25px;
    font-size: 14px;
  }
  .dashbored-wrap .top-menu-wrap {
    padding: 5px;
    min-height: 60px;
  }
  .dashbored-wrap .hamburger .dash-title h6 {
    font-size: 12px;
  }
  .dashbored-wrap .hamburger .dash-title h6 .material-icons {
    font-size: 16px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (max-width: 768px) {
  .detail-list {
    position: fixed;
    top: 0;
    left: -100%;
    width: 80%;
    max-width: 300px;
    height: 100vh;
    background: #efeeee;
    z-index: 1000;
    transition: left 0.3s ease;
    padding-top: calc(var(--app-header) + 5px);
  }
  .detail-list.mobile-open {
    left: 0;
  }
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;
  }
  .mobile-menu-overlay.active {
    display: block;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (max-width: 480px) {
  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  h6 {
    font-size: 12px;
  }
  p {
    font-size: 14px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) and (max-width: 320px) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 14px;
  }
  h5 {
    font-size: 12px;
  }
  h6 {
    font-size: 11px;
  }
  p {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  .goog-te-banner-frame {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 60px !important;
    max-height: 300px !important;
    margin-bottom: 0 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
  }
  iframe.skiptranslate,
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  iframe[class*=skiptranslate],
  iframe[id*=container] {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 60px !important;
    max-height: 300px !important;
    margin-bottom: 0 !important;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
  }
  .goog-te-banner-frame skipptr {
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 16px !important;
    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;
    min-height: 60px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .goog-te-banner-frame > * {
    max-height: 100% !important;
    overflow-y: auto !important;
  }
}
/* Dark mode foundation for dashboard + child routes */
:host-context(body.theme-dark) {
  /* Child routes rendered via router-outlet */
}
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .setting-dashboard .container1,
:host-context(body.theme-dark) .setting-dashboard .commonclass {
  background: #111827 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .setting-dashboard .left-user {
  background: #0d1b2e !important;
  border-right: 1px solid rgba(94, 161, 216, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-title {
  background: #0d1b2e !important;
  border-bottom: 1px solid rgba(94, 161, 216, 0.2) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .setting-dashboard .detail-list {
  background: transparent !important;
}
:host-context(body.theme-dark) .setting-dashboard .submission-field {
  border-left: 1px solid rgba(94, 161, 216, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard ul li {
  color: #94a3b8 !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08) !important;
}
:host-context(body.theme-dark) .setting-dashboard ul li:hover {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .setting-dashboard ul li.active {
  background: rgba(94, 161, 216, 0.25) !important;
  color: #ffffff !important;
  border-left: 3px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .setting-dashboard ul li:before {
  background: rgba(94, 161, 216, 0.2) !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-elemenet > div {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .setting-dashboard .left-user .selected-item {
  background: rgba(94, 161, 216, 0.25) !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-title h6,
:host-context(body.theme-dark) .setting-dashboard .dash-title .h6 {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-title span {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .setting-dashboard .navbar-toggler {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .detail-list,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .com-record,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .table-wrap,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .box,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .filter,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .tab-content,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .card,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap .mat-mdc-card {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap p,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap span,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap label,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap li,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap td,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap th,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h1,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h2,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h3,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h4,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h5,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap h6 {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap table,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap thead,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap tbody,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap tr,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap td,
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap th {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) ::ng-deep .dashbored-wrap tbody tr:hover {
  background: #1f2937 !important;
}

/* Dark mode polish: stronger contrast + no white surfaces */
:host-context(body.theme-dark) {
  /* Hardening: catch routed child content outside dashbored-wrap */
  /* Title/header bars: remove white patches */
  /* Title card container (child pages) */
  /* ── CSS-variable-driven table cells (child routes) ── */
  /* No-data rows should also be dark */
  /* Cards / boxes in child routes */
  /* Skeleton loaders */
  /* Mobile tile cards inside dashbored-wrap */
  /* Text / label colour inside child routes */
  /* Consultation description / reason cell text — explicit colours to prevent override */
  /* Badge dark mode colours — these ::ng-deep rules re-apply colours that the
     generic span rule above would otherwise overwrite in child routes */
}
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .dashbored-wrap .top-menu-wrap,
:host-context(body.theme-dark) .dashbored-wrap .detail-description,
:host-context(body.theme-dark) .dashbored-wrap .table-wrap,
:host-context(body.theme-dark) .dashbored-wrap .com-record,
:host-context(body.theme-dark) .dashbored-wrap .mobile-design,
:host-context(body.theme-dark) .dashbored-wrap .tile,
:host-context(body.theme-dark) .dashbored-wrap .box,
:host-context(body.theme-dark) .dashbored-wrap .filter,
:host-context(body.theme-dark) .dashbored-wrap .search-input,
:host-context(body.theme-dark) .dashbored-wrap .detail-list {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dashbored-wrap p,
:host-context(body.theme-dark) .dashbored-wrap span,
:host-context(body.theme-dark) .dashbored-wrap label,
:host-context(body.theme-dark) .dashbored-wrap li,
:host-context(body.theme-dark) .dashbored-wrap td,
:host-context(body.theme-dark) .dashbored-wrap th,
:host-context(body.theme-dark) .dashbored-wrap h1,
:host-context(body.theme-dark) .dashbored-wrap h2,
:host-context(body.theme-dark) .dashbored-wrap h3,
:host-context(body.theme-dark) .dashbored-wrap h4,
:host-context(body.theme-dark) .dashbored-wrap h5,
:host-context(body.theme-dark) .dashbored-wrap h6,
:host-context(body.theme-dark) .dashbored-wrap i {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dashbored-wrap table,
:host-context(body.theme-dark) .dashbored-wrap thead,
:host-context(body.theme-dark) .dashbored-wrap tbody,
:host-context(body.theme-dark) .dashbored-wrap tr,
:host-context(body.theme-dark) .dashbored-wrap td,
:host-context(body.theme-dark) .dashbored-wrap th {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dashbored-wrap tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .dashbored-wrap [style*="background: white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: #fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:#fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: #ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:#ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: #fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:#fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: #ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:#ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: rgb(255, 255, 255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:rgb(255,255,255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: rgb(255, 255, 255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:rgb(255,255,255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: var(--white)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: var(--white)"] {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .setting-dashboard router-outlet ~ *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]),
:host-context(body.theme-dark) .setting-dashboard router-outlet + *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]),
:host-context(body.theme-dark) .setting-dashboard .submission-field > *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]),
:host-context(body.theme-dark) .setting-dashboard .submission-field > * *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]),
:host-context(body.theme-dark) .setting-dashboard .detail-description,
:host-context(body.theme-dark) .setting-dashboard .detail-description *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]),
:host-context(body.theme-dark) .setting-dashboard .scroll-div,
:host-context(body.theme-dark) .setting-dashboard .scroll-div *:not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-reason-cell]):not([class*=consult-card]):not([class*=consult-profile]) {
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard router-outlet ~ *[style*=background],
:host-context(body.theme-dark) .setting-dashboard router-outlet + *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .submission-field *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .detail-description *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .scroll-div *[style*=background] {
  background: #111827 !important;
  background-color: #111827 !important;
}
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-card,
:host-context(body.theme-dark) .setting-dashboard .mat-card,
:host-context(body.theme-dark) .setting-dashboard .mat-expansion-panel,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .setting-dashboard .table,
:host-context(body.theme-dark) .setting-dashboard table,
:host-context(body.theme-dark) .setting-dashboard tbody,
:host-context(body.theme-dark) .setting-dashboard tr,
:host-context(body.theme-dark) .setting-dashboard td {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-title,
:host-context(body.theme-dark) .setting-dashboard .submission-field .hamburger .dash-title,
:host-context(body.theme-dark) .setting-dashboard .left-user .dash-title,
:host-context(body.theme-dark) .page-section-header,
:host-context(body.theme-dark) .page-section-title {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .dash-text,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .dash-text > div,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .main-title,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .title-tile,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .page-section-header,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .page-header,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .header-section {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep table,
:host-context(body.theme-dark) ::ng-deep thead,
:host-context(body.theme-dark) ::ng-deep tbody,
:host-context(body.theme-dark) ::ng-deep tr,
:host-context(body.theme-dark) ::ng-deep td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}
:host-context(body.theme-dark) ::ng-deep th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}
:host-context(body.theme-dark) ::ng-deep tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}
:host-context(body.theme-dark) ::ng-deep tr.no-data-row,
:host-context(body.theme-dark) ::ng-deep tr.no-data-row:hover {
  background: var(--fc-bg) !important;
}
:host-context(body.theme-dark) ::ng-deep tr.no-data-row td,
:host-context(body.theme-dark) ::ng-deep tr.no-data-row:hover td {
  color: var(--fc-fg) !important;
}
:host-context(body.theme-dark) ::ng-deep .box,
:host-context(body.theme-dark) ::ng-deep .tile,
:host-context(body.theme-dark) ::ng-deep .card,
:host-context(body.theme-dark) ::ng-deep .stats-cards .box {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
  color: var(--fc-fg) !important;
}
:host-context(body.theme-dark) ::ng-deep .skeleton-box,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container {
  background: var(--fc-skel) !important;
}
:host-context(body.theme-dark) ::ng-deep .skeleton-box table, :host-context(body.theme-dark) ::ng-deep .skeleton-box thead, :host-context(body.theme-dark) ::ng-deep .skeleton-box th, :host-context(body.theme-dark) ::ng-deep .skeleton-box td, :host-context(body.theme-dark) ::ng-deep .skeleton-box tr,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile table,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile thead,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile th,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile td,
:host-context(body.theme-dark) ::ng-deep .skeleton-tile tr,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container table,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container thead,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container th,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container td,
:host-context(body.theme-dark) ::ng-deep .skeleton-table-container tr,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container table,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container thead,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container th,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container td,
:host-context(body.theme-dark) ::ng-deep .skeleton-mobile-container tr {
  background: var(--fc-skel) !important;
}
:host-context(body.theme-dark) ::ng-deep .skeleton-text,
:host-context(body.theme-dark) ::ng-deep .skeleton-bold,
:host-context(body.theme-dark) ::ng-deep .skeleton-count,
:host-context(body.theme-dark) ::ng-deep .skeleton-checkbox,
:host-context(body.theme-dark) ::ng-deep .skeleton-icon,
:host-context(body.theme-dark) ::ng-deep .skeleton-image,
:host-context(body.theme-dark) ::ng-deep .skeleton-price {
  background: linear-gradient(90deg, var(--fc-skel) 25%, var(--fc-skel-wave) 50%, var(--fc-skel) 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) ::ng-deep .mobile-design,
:host-context(body.theme-dark) ::ng-deep .mobile-design .tile {
  background: var(--fc-bg) !important;
  border-color: var(--fc-border) !important;
}
:host-context(body.theme-dark) ::ng-deep p:not([class*=consult-card]), :host-context(body.theme-dark) ::ng-deep span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]):not([class*=consult-]), :host-context(body.theme-dark) ::ng-deep label,
:host-context(body.theme-dark) ::ng-deep li, :host-context(body.theme-dark) ::ng-deep h1, :host-context(body.theme-dark) ::ng-deep h2, :host-context(body.theme-dark) ::ng-deep h3,
:host-context(body.theme-dark) ::ng-deep h4, :host-context(body.theme-dark) ::ng-deep h5, :host-context(body.theme-dark) ::ng-deep h6, :host-context(body.theme-dark) ::ng-deep b, :host-context(body.theme-dark) ::ng-deep i {
  color: var(--fc-fg) !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-reason-cell__flow {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-reason-cell__reason {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-reason-cell__empty {
  color: #64748b !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-card-reason {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-card-flow-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .consult-profile-link {
  color: #93c5fd !important;
  background: none !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-completed {
  background-color: #052e16 !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-scheduled {
  background-color: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-rescheduled {
  background-color: #2e1065 !important;
  color: #c4b5fd !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-canceled,
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-cancelled,
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-did-not-happen {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-pending {
  background-color: #451a03 !important;
  color: #fcd34d !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-approved {
  background-color: #052e16 !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-rejected {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-reworkrequested {
  background-color: #451a03 !important;
  color: #fcd34d !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.status-cancelled {
  background-color: #1f2937 !important;
  color: #9ca3af !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.completed {
  background-color: #052e16 !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge-modern.failed {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) ::ng-deep .badge.badge-success {
  background: #052e16 !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) ::ng-deep .badge.badge-danger {
  background: #450a0a !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) ::ng-deep .badge.badge-secondary {
  background: #1f2937 !important;
  color: #9ca3af !important;
}
:host-context(body.theme-dark) ::ng-deep .badge.badge-warning {
  background: #451a03 !important;
  color: #fcd34d !important;
}
:host-context(body.theme-dark) ::ng-deep .badge.badge-info {
  background: #0c3443 !important;
  color: #67e8f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge.status-pending,
:host-context(body.theme-dark) ::ng-deep .status-badge.status-reworkrequested {
  background: #451a03 !important;
  color: #fcd34d !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge.status-approved {
  background: #052e16 !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge.status-rejected {
  background: #450a0a !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) ::ng-deep .status-badge.status-cancelled {
  background: #1f2937 !important;
  color: #9ca3af !important;
}

body.theme-dark .setting-dashboard {
  background: #111827 !important;
}

body.theme-dark .setting-dashboard .left-user {
  background: #0d1b2e !important;
  border-right: 1px solid rgba(94, 161, 216, 0.3) !important;
}

body.theme-dark .setting-dashboard .dash-title {
  background: #0d1b2e !important;
  border-bottom: 1px solid rgba(94, 161, 216, 0.2) !important;
}

body.theme-dark .setting-dashboard .dash-title h6,
body.theme-dark .setting-dashboard .dash-title .h6 {
  color: #5ea1d8 !important;
}

body.theme-dark .setting-dashboard .dash-title span {
  color: #5ea1d8 !important;
}

body.theme-dark .setting-dashboard ul li {
  color: #94a3b8 !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08) !important;
}

body.theme-dark .setting-dashboard ul li:hover {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #e2e8f0 !important;
}

body.theme-dark .setting-dashboard ul li.active {
  background: rgba(94, 161, 216, 0.25) !important;
  color: #ffffff !important;
  border-left: 3px solid #5ea1d8 !important;
}

body.theme-dark .setting-dashboard .left-user .selected-item {
  background: rgba(94, 161, 216, 0.25) !important;
  color: #ffffff !important;
}

body.theme-dark .setting-dashboard .dash-elemenet > div {
  color: #94a3b8 !important;
}

body.theme-dark .setting-dashboard .submission-field {
  border-left: 1px solid rgba(94, 161, 216, 0.3) !important;
}

body.theme-dark .page-section-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
}

body.theme-dark .page-section-title {
  color: #e5e7eb !important;
}

/* ── Dark mode scrollbar + scroll container background fixes ── */
body.theme-dark .scroll-div {
  background: #111827 !important;
  background-color: #111827 !important;
}

body.theme-dark .scroll-div::-webkit-scrollbar,
body.theme-dark .submission-field::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .scroll-div::-webkit-scrollbar-track,
body.theme-dark .submission-field::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .scroll-div::-webkit-scrollbar-thumb,
body.theme-dark .submission-field::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .scroll-div::-webkit-scrollbar-thumb:hover,
body.theme-dark .submission-field::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .scroll-div::-webkit-scrollbar-corner,
body.theme-dark .submission-field::-webkit-scrollbar-corner {
  background: #111827;
}

body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/user-dashboard.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AACA,4DAAA;AACA;EACE,aAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE;IACE,cAAA;EAEF;AACF;AAWA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AATF;AAUE;EACE,YAAA;EACA,mBAAA;AARJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AARJ;AAUE;EACE,aAAA;EACA,mBAAA;AARJ;AAUE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AARJ;AAUE;EACE,aAAA;EACA,mBAAA;AARJ;AAUE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AARJ;AAWE;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAVJ;AAYE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAXJ;AAaE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;AAXJ;AAaE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAXJ;AAaE;EACE,mBAAA;AAXJ;AAmBE;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AAlBJ;AAoBE;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AAlBJ;AAoBE;EACE,WAAA;AAlBJ;AAoBE;EACE;mBAAA;EAEA,WAAA;AAlBJ;AAoBE;EACE,WAAA;AAlBJ;AAoBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EAGA,wBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AAtBJ;AAwBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAtBJ;AAwBE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAtBJ;AA+BU;EACE,6BAAA;AA7BZ;AAmCE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAjCJ;AAmCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCJ;AAmCE;EACE,2BAAA;EACA,kBAAA;EACA,mCAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AAjCJ;AAmCE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;AAjCJ;AAmCE;EACE,WAAA;AAjCJ;AAmCE;EACE,WAAA;AAjCJ;AAmCE;EACE,mBAAA;AAjCJ;AAmCE;EACE,gBAAA;EACA,gBAAA;EAEA,gBAAA;AAlCJ;AAoCE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAlCJ;AAoCE;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAlCJ;AAoCE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gCAAA;AAlCJ;AAoCE;EACE,gCAAA;AAlCJ;AAoCE;EACE,kBAAA;AAlCJ;AAoCE;EACE,WAAA;EACA,kBAAA;AAlCJ;AAmCI;EACE,YAAA;EACA,WAAA;AAjCN;AAkCM;EACE,WAAA;AAhCR;AAoCE;EACE,eAAA;EACA,iCAAA;AAlCJ;AAsCI;EACE,yBAAA;AApCN;AAqCM;EACE,WAAA;AAnCR;AAsCI;EACE,mBAAA;AApCN;AAsCI;EACE,aAAA;EACA,mBAAA;AApCN;AA+CE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AA7CJ;AAiDE;EACE,OAAA;AA/CJ;AAiDE;EACE,aAAA;EACA,YAAA;AA/CJ;AAiDE;EACE,aAAA;EACA,WAAA;AA/CJ;AAiDE;EACE,OAAA;AA/CJ;AAiDE;EACE,kBAAA;AA/CJ;AAkDE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAhDJ;AAkDE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAhDJ;AAmDE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAjDJ;AAoDE;EACE,aAAA;AAlDJ;AAoDM;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAlDR;AAmDQ;EACE,kBAAA;AAjDV;AAoDM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAlDR;AAuDI;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;AAtDN;AA+DE;EACE,aAAA;AA7DJ;;AAgEA;EAEI;IACE,aAAA;EA9DJ;EAgEE;IACE,WAAA;IACA,SAAA;EA9DJ;EAgEE;IACE,eAAA;EA9DJ;EA+DI;IACE,YAAA;IACA,WAAA;EA7DN;EA8DM;IACE,OAAA;EA5DR;EAgEE;IACE,aAAA;EA9DJ;EA+DI;IACE,aAAA;EA7DN;EAoEI;IACE,WAAA;EAlEN;EAqEE;IACE,aAAA;EAnEJ;EAqEE;IACE,UAAA;EAnEJ;EAoEI;IACE,aAAA;EAlEN;EAqEE;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EAnEJ;EAoEI;IACE,gBAAA;IACA,aAAA;EAlEN;EAmEM;IACE,6BAAA;EAjER;EAmEM;IACE,yBAAA;EAjER;EAmEM;IACE,2BAAA;IACA,oDAAA;EAjER;EAmEM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAjER;EAkEQ;IACE,6BAAA;IACA,sBAAA;EAhEV;EAqEM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EAnER;EAoEQ;IACE,aAAA;IACA,mBAAA;EAlEV;EAsEM;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EApER;EAsEM;IACE,aAAA;IACA,uBAAA;EApER;EAqEQ;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EAnEV;EAqEQ;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EAnEV;EAuEI;IACE,aAAA;EArEN;EAsEM;IACE,OAAA;IACA,YAAA;EApER;AACF;AA0EA,yCAAA;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAzEF;AA0EE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAxEJ;AA0EE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AAxEJ;AAyEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AAvEN;AAyEI;EACE,2BAAA;AAvEN;AAwEM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAtER;AAuEQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AArEV;AAsEU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AApEZ;AAsEU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AAtEZ;;AA6EA;EACE,kBAAA;EACA,aAAA,EAAA,uCAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;AA1EF;;AA4EA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAzEF;;AA2EA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AAxEF;;AA0EA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvEF;;AAyEA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAtEF;;AAwEA;EACE,8BAAA;EACA,kBAAA;AArEF;;AAuEA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AApEF;;AAsEA,0BAAA;AACA;EACE,8BAAA;EACA,kBAAA;AAnEF;;AAsEA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA,EAAA,kCAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAnEF;;AAqEA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAlEF;;AAoEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAnEF;;AAqEA;EACE,gBAAA;EACA,iCAAA,EAAA,qDAAA;EACA,wBAAA,EAAA,gDAAA;EACA,WAAA;EACA,oBAAA;AAlEF;AAmEE;EACE,oBAAA,EAAA,+BAAA;AAjEJ;;AAqEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAlEF;;AAqEA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AAlEF;;AAoEA;EACE,0BAAA;AAjEF;;AAoEA;EACE,SAAA;EACA,4BAAA;AAjEF;;AAoEA,kBAAA;AAGE;EACE,WAAA;AAnEJ;AAsEI;EACE,cAAA;AApEN;AAuEQ;EACE,iBAAA;AArEV;AAuEU;EACE,aAAA;AArEZ;AA4EM;EACE,aAAA;AA1ER;AA6EM;EACE,WAAA;AA3ER;AAkFU;EACE,aAAA;AAhFZ;AAyFE;EACE,UAAA;EACA,wBAAA;AAvFJ;AAyFM;EACE,UAAA;EACA,wBAAA;AAvFR;AA4FE;EACE,0BAAA;AA1FJ;AA6FE;EACE,UAAA;EACA,wBAAA;AA3FJ;AA8FE;EACE,cAAA;AA5FJ;AA8FI;EACE,mBAAA;EAEA,mCAAA;AA7FN;AA+FM;EACE,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA7FR;AA+FQ;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AA7FV;;AAwGE;EACE,mCAAA;AArGJ;;AAwGA;;gDAAA;AAGA;EACE,qBAAA;EACA;IACE,mBAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,cAAA;EArGF;EAwGA,4CAAA;EACA;IACE,wBAAA;IACA,6BAAA;IACA,qBAAA;IACA,qBAAA;EAtGF;EAyGA;IACE,yBAAA;IACA,gBAAA;IACA,UAAA;EAvGF;EA0GA;IACE,mBAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;EAxGF;EA2GA,wBAAA;EACA;IACE,WAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,8BAAA;IACA,aAAA;IACA,cAAA;EAzGF;EA4GA,+CAAA;EACA;IACE,yBAAA;EA1GF;EA6GA,qEAAA;EACA;IACE,0BAAA;IACA,MAAA;IACA,qBAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,wBAAA;IACA,kCAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,0CAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;EA3GF;EA8GA;IACE,qBAAA;IACA,mBAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,wBAAA;EA5GF;EA+GA,mDAAA;EACA;IACE,aAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,UAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;EA7GF;EAgHA;IACE,aAAA;EA9GF;EAiHA,6CAAA;EACA;IACE,wBAAA;IACA,mBAAA;IACA,2BAAA;IACA,sBAAA;IACA,gBAAA;IACA,2BAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,8BAAA;IACA,qBAAA;EA/GF;EAkHA,0CAAA;EACA;IACE,yBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;IACA,kBAAA;IACA,YAAA;IACA,8BAAA;IACA,qBAAA;EAhHF;EAmHA,gCAAA;EACA;IACE,gBAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;EAjHF;EAoHA,8CAAA;EACA;IACE,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,2BAAA;IACA,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,uBAAA;IACA,8BAAA;IACA,qBAAA;EAlHF;EAqHA,mCAAA;EACA;IACE,SAAA;IACA,WAAA;IACA,cAAA;IACA,YAAA;IACA,QAAA;IACA,kBAAA;IACA,mBAAA;IACA,2BAAA;IACA,QAAA;IACA,WAAA;EAnHF;EAsHA;;;IAGE,WAAA;IACA,WAAA;IACA,OAAA;IACA,2BAAA;EApHF;EAuHA,mCAAA;EACA;IACE,8BAAA;IACA,sBAAA;IACA,kBAAA;EArHF;EAwHA;IACE,WAAA;EAtHF;EAyHA,6BAAA;EACA;IACE,WAAA;IACA,OAAA;IACA,kBAAA;EAvHF;EA0HA;IACE,WAAA;IACA,kBAAA;IACA,MAAA;IACA,YAAA;IACA,aAAA;EAxHF;EA2HA,6DAAA;EACA;IACE,cAAA;IACA,WAAA;EAzHF;EA4HA,yCAAA;EACA;;IAEE,kBAAA;IACA,UAAA;EA1HF;EA6HA,gEAAA;EACA;;IAEE,UAAA;EA3HF;EA8HA,6DAAA;EACA;;IAEE,qBAAA;IACA,oBAAA;EA5HF;EA8HE;;IACE,wBAAA;EA3HJ;EA8HE;;IACE,2BAAA;IACA,qBAAA;IACA,oBAAA;EA3HJ;EA8HE;;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EA3HJ;EA8HE;;IACE,qBAAA;IACA,oBAAA;EA3HJ;EA8HE;;IACE,qBAAA;IACA,oBAAA;EA3HJ;EA8HE;;IACE,qBAAA;IACA,oBAAA;EA3HJ;EA8HE;;IACE,qBAAA;IACA,oBAAA;EA3HJ;EA8HE;;IACE,oBAAA;IACA,qBAAA;EA3HJ;EA8HE;;IACE,qBAAA;IACA,oBAAA;EA3HJ;EA+HA,+EAAA;EACA;;;;;;;;;;;IAWE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EA7HF;EAgIA;IACE,2BAAA;EA9HF;EAiIA;IACE,UAAA;EA/HF;EAkIA;IACE,aAAA,EAAA,sCAAA;EAhIF;EAmIA;IACE,aAAA;EAjIF;AACF;AAyIA;EAEI;IACE,gBAAA;IACA,kBAAA;EAxIJ;EA0IE;IACE,kBAAA;IACA,aAAA;EAxIJ;EA2II;IACE,aAAA;IACA,eAAA;EAzIN;AACF;AA+IA;EAEI;IACE,gBAAA;IACA,kBAAA;EA9IJ;EAgJE;IACE,kBAAA;IACA,aAAA;EA9IJ;AACF;AAmJA;EAEI;IACE,gBAAA;EAlJJ;EAoJE;IACE,kBAAA;EAlJJ;AACF;AAuJA;EAEI;IACE,gBAAA;IACA,kBAAA;EAtJJ;EAwJE;IACE,kBAAA;IACA,aAAA;EAtJJ;EAyJI;IACE,uBAAA;IACA,gBAAA;EAvJN;AACF;AA4JE;EAEI;IACE,aAAA;EA3JN;EA6JI;IACE,WAAA;IACA,cAAA;IACA,aAAA;EA3JN;EA6JI;IACE,eAAA;IACA,SAAA;EA3JN;EA4JM;IACE,wBAAA;IACA,gBAAA;IACA,aAAA;EA1JR;EA6JI;IACE,kBAAA;IACA,eAAA;IACA,SAAA;EA3JN;EA6JI;IACE,sBAAA;IACA,qBAAA;IACA,SAAA;EA3JN;AACF;AAgKE;EAEI;IACE,aAAA;EA/JN;EAiKI;IACE,WAAA;IACA,cAAA;IACA,aAAA;EA/JN;EAiKI;IACE,sBAAA;IACA,SAAA;EA/JN;EAgKM;IACE,WAAA;IACA,gBAAA;IACA,aAAA;EA9JR;EA+JQ;IACE,eAAA;EA7JV;EAiKI;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;EA/JN;EAiKI;IACE,WAAA;IACA,8BAAA;IACA,mBAAA;EA/JN;EAiKI;IACE,cAAA;EA/JN;EAgKM;IACE,eAAA;IACA,SAAA;EA9JR;AACF;AAoKE;EAEI;IACE,aAAA;EAnKN;EAqKI;IACE,WAAA;IACA,cAAA;IACA,aAAA;EAnKN;EAqKI;IACE,sBAAA;IACA,SAAA;EAnKN;EAoKM;IACE,WAAA;IACA,gBAAA;IACA,aAAA;EAlKR;EAmKQ;IACE,eAAA;EAjKV;EAoKU;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAlKZ;EAuKI;IACE,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;EArKN;EAuKI;IACE,WAAA;IACA,8BAAA;IACA,mBAAA;EArKN;EAuKQ;IACE,eAAA;EArKV;EAuKQ;IACE,WAAA;IACA,YAAA;EArKV;EAyKI;IACE,cAAA;EAvKN;EAwKM;IACE,eAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;EAtKR;EAuKQ;IACE,eAAA;EArKV;AACF;AA4KE;EAEI;IACE,YAAA;EA3KN;EA6KI;IACE,QAAA;EA3KN;EA4KM;IACE,YAAA;EA1KR;EA2KQ;IACE,eAAA;EAzKV;EA4KU;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA1KZ;EA+KI;IACE,YAAA;IACA,gBAAA;EA7KN;EAgLM;IACE,eAAA;EA9KR;EA+KQ;IACE,eAAA;EA7KV;AACF;AAwLE;EACE;IACE,eAAA;IACA,MAAA;IACA,WAAA;IACA,UAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,0BAAA;IACA,0CAAA;EAtLJ;EAwLI;IACE,OAAA;EAtLN;EA0LE;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;IACA,YAAA;IACA,aAAA;EAxLJ;EA0LI;IACE,cAAA;EAxLN;AACF;AAgME;EACE;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;EAgME;IACE,eAAA;EA9LJ;AACF;AAiME;EACE;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;EAiME;IACE,eAAA;EA/LJ;AACF;AAsMA;EAEE;IACE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,oCAAA;IACA,wCAAA;IACA,qDAAA;IACA,8BAAA;IACA,qBAAA;IACA,yBAAA;EArMF;EAyMA;;;;IAIE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,8BAAA;IACA,qBAAA;IACA,yBAAA;IACA,2BAAA;IACA,6BAAA;IACA,oCAAA;IACA,wCAAA;IACA,qDAAA;EAvMF;EA2MA;IACE,oCAAA;IACA,wCAAA;IACA,qDAAA;IACA,wBAAA;IACA,iEAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,6BAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;EAzMF;EA8ME;IACE,2BAAA;IACA,2BAAA;EA5MJ;AACF;AAgNA,sDAAA;AACA;EA+EE,4CAAA;AA5RF;AA+ME;;;EAGE,8BAAA;EACA,yBAAA;AA7MJ;AAiNE;EACE,8BAAA;EACA,0DAAA;AA/MJ;AAmNE;EACE,8BAAA;EACA,2DAAA;EACA,yBAAA;AAjNJ;AAqNE;EACE,kCAAA;AAnNJ;AAuNE;EACE,yDAAA;AArNJ;AAyNE;EACE,yBAAA;EACA,6DAAA;AAvNJ;AA0NE;EACE,+CAAA;EACA,yBAAA;AAxNJ;AA2NE;EACE,+CAAA;EACA,yBAAA;EACA,yCAAA;AAzNJ;AA4NE;EACE,8CAAA;AA1NJ;AA8NE;EACE,yBAAA;AA5NJ;AAgOE;EACE,+CAAA;EACA,yBAAA;AA9NJ;AAiOE;;EAEE,yBAAA;AA/NJ;AAkOE;EACE,yBAAA;AAhOJ;AAmOE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAjOJ;AAqOE;;;;;;;;;EASE,8BAAA;EACA,yBAAA;EACA,kDAAA;EACA,2BAAA;AAnOJ;AAsOE;;;;;;;;;;;;EAYE,yBAAA;AApOJ;AAuOE;;;;;;EAME,8BAAA;EACA,kDAAA;AArOJ;AAwOE;EACE,8BAAA;AAtOJ;;AA0OA,4DAAA;AACA;EAsEE,iEAAA;EAsCA,4CAAA;EAYA,uCAAA;EAcA,yDAAA;EAqBA,qCAAA;EAOA,kCAAA;EAUA,qBAAA;EAyBA,4CAAA;EAOA,4CAAA;EAOA,uFAAA;EAQA;wEAAA;AAtbF;AA4NE;;;;;;;;;;;EAWE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA1NJ;AA6NE;;;;;;;;;;;;;EAaE,yBAAA;AA3NJ;AA8NE;;;;;;EAME,8BAAA;EACA,iDAAA;AA5NJ;AA+NE;EACE,8BAAA;AA7NJ;AAgOE;;;;;;;;;;;;;;;;;;EAkBE,8BAAA;EACA,oCAAA;EACA,yBAAA;AA9NJ;AAkOE;;;;;;;;EAQE,yBAAA;EACA,iDAAA;AAhOJ;AAmOE;;;;;EAKE,8BAAA;EACA,oCAAA;AAjOJ;AAoOE;;;;;;;;;;;EAWE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlOJ;AAsOE;;;;;EAKE,kCAAA;EACA,wCAAA;EACA,yBAAA;EACA,iDAAA;AApOJ;AAwOE;;;;;;;EAOE,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;AAtOJ;AA0OE;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AAxOJ;AA2OE;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AAzOJ;AA4OE;EACE,yCAAA;AA1OJ;AA8OE;;EAEE,mCAAA;AA5OJ;AA6OI;;EAAK,8BAAA;AAzOT;AA6OE;;;;EAIE,oCAAA;EACA,yCAAA;EACA,8BAAA;AA3OJ;AA+OE;;;;EAIE,qCAAA;AA7OJ;AA8OI;;;;;;;;;;;;;;;;EAA2B,qCAAA;AA5N/B;AA+NE;;;;;;;EAOE,8GAAA;EAMA,qCAAA;AAlOJ;AAsOE;;EAEE,mCAAA;EACA,yCAAA;AApOJ;AAwOE;;;EAGE,8BAAA;AAtOJ;AA0OE;EAAyC,yBAAA;AAvO3C;AAwOE;EAAyC,yBAAA;AArO3C;AAsOE;EAAyC,yBAAA;AAnO3C;AAoOE;EAAyC,yBAAA;AAjO3C;AAkOE;EAAyC,yBAAA;AA/N3C;AAgOE;EAAyC,yBAAA;EAA2B,2BAAA;AA5NtE;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;;;EAGE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,oCAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;;EAEE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;AAgOE;EACE,8BAAA;EACA,yBAAA;AA9NJ;;AAuOA;EACE,8BAAA;AApOF;;AAwOA;EACE,8BAAA;EACA,0DAAA;AArOF;;AAwOA;EACE,8BAAA;EACA,2DAAA;AArOF;;AAwOA;;EAEE,yBAAA;AArOF;;AAwOA;EACE,yBAAA;AArOF;;AAyOA;EACE,yBAAA;EACA,6DAAA;AAtOF;;AAyOA;EACE,+CAAA;EACA,yBAAA;AAtOF;;AAyOA;EACE,+CAAA;EACA,yBAAA;EACA,yCAAA;AAtOF;;AAyOA;EACE,+CAAA;EACA,yBAAA;AAtOF;;AAyOA;EACE,yBAAA;AAtOF;;AA0OA;EACE,yDAAA;AAvOF;;AA2OA;EACE,4DAAA;EACA,yBAAA;AAxOF;;AA2OA;EACE,yBAAA;AAxOF;;AA2OA,kEAAA;AACA;EACE,8BAAA;EACA,oCAAA;AAxOF;;AA0OA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AAvOF;;AAyOA;;EAEE,mBAAA;EACA,kBAAA;AAtOF;;AAwOA;;EAEE,mBAAA;EACA,kBAAA;AArOF;;AAuOA;;EAEE,mBAAA;AApOF;;AAsOA;;EAEE,mBAAA;AAnOF;;AAqOA;EACE,8BAAA;EACA,oCAAA;AAlOF;;AAoOA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AAjOF;;AAmOA;;EAEE,mBAAA;EACA,kBAAA;AAhOF;;AAkOA;;EAEE,mBAAA;EACA,kBAAA;AA/NF;;AAiOA;;EAEE,mBAAA;AA9NF","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n/* Show mobile menu toggle only on mobile; hide on desktop */\n.mob-menu {\n  display: none;\n}\n\n.mob-hide {\n  display: block;\n}\n\n@media (max-width: 955px) {\n  .mob-menu {\n    display: block;\n  }\n  \n}\n\n// Responsive breakpoints\n$mobile-small: 320px;\n$mobile: 480px;\n$tablet: 768px;\n$tablet-large: 1024px;\n$desktop: 1200px;\n$desktop-large: 1440px;\n$desktop-xl: 1920px;\n\n.dashbored-wrap {\n  width: 100%;\n  height: 100vh;\n  background: var(--fc-bg, #fff);\n  .logo {\n    width: 100px;\n    margin-right: 100px;\n  }\n  .top-menu-wrap {\n    display: flex;\n    align-items: center;\n    padding: 20px 10px;\n  }\n  .user-name {\n    display: flex;\n    align-items: center;\n  }\n  .user-details {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  .user-name p {\n    display: flex;\n    align-items: center;\n  }\n  .user-name span {\n    width: 40px;\n    height: 40px;\n    background: red;\n    border-radius: 50%;\n    display: block;\n    margin-right: 10px;\n  }\n\n  .top-menu-wrap {\n    width: 100%;\n    height: 100px;\n\n    background: #fff;\n  }\n  .dash-details {\n    width: 100%;\n    display: flex;\n    max-height: 100vh;\n\n    /* background: green; */\n  }\n  .detail-list {\n    max-width: 250px;\n    width: 100%;\n    padding: 20px 10px;\n    background-color: #efeeee;\n    color: #212529;\n    position: fixed;\n    top: calc(var(--app-header) + 24px);\n    height: calc(100vh - 120px);\n  }\n  ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  p {\n    margin-bottom: 10px;\n  }\n  // .scroll-div {\n  //   position: absolute;\n  //   top: 120px !important;\n  //   width: 100%;\n  // }\n\n  ul li {\n    margin-bottom: 10px;\n    height: 40px;\n\n    padding: 0px 10px;\n    position: relative;\n    z-index: 1;\n    color: #212529;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  }\n  ul li:before {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0px;\n    position: absolute;\n    background: #fff;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    width: 0%;\n    z-index: -1;\n  }\n  ul li:hover {\n    color: #000;\n  }\n  ul li:hover:before {\n    /* background: #fff;\n    color: #212529; */\n    width: 100%;\n  }\n  .table-bordered {\n    border: 0px;\n  }\n  .detail-description {\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n    // width: calc(100% - 250px);\n    position: absolute;\n    // left: 250px;\n    // top: 120px;\n    /* background: purple; */\n  }\n\n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n  }\n  h3 {\n    position: relative;\n    z-index: 3;\n    color: #fff;\n    font-weight: normal;\n  }\n  .com-record {\n    width: calc(100% - 250px);\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 0;\n    padding: 20px 30px 30px;\n    // position: fixed;\n    // top:80px;\n    // left:250px;\n    // background: white;\n    // z-index: 100;\n    .followers-tag {\n      .box {\n        .text {\n          p.number {\n            font-family: Arial !important;\n          }\n        }\n      }\n    }\n  }\n  .com-record:after {\n    content: \"\";\n    width: 100%;\n    height: 60%;\n    /* background: gray; */\n    top: 0px;\n    position: absolute;\n    left: 0px;\n    z-index: 0;\n    background: #5ea1d8;\n  }\n  .ico-box {\n    width: 40px;\n    height: 40px;\n    background: #efeeee;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .table-wrap {\n    padding: 30px 30px 30px 0px;\n    position: absolute;\n    top: calc(var(--app-header) + 54px);\n    width: calc(100% - 30px);\n    width: 100%;\n    left: 0px;\n    /* width:calc(100% - 76px); */\n  }\n  .box {\n    width: auto;\n    padding: 5px 10px;\n    background: #fff;\n    margin-right: 20px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  }\n  .filter-ico li {\n    width: 40px;\n  }\n  .filter-ico li i {\n    color: #000;\n  }\n  .text {\n    padding-right: 10px;\n  }\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n    // max-height: 400px;\n    overflow-y: auto;\n  }\n  table {\n    margin-bottom: 20px;\n    width: 100%;\n    background: white;\n    border-radius: 0 0 8px 8px;\n    overflow: hidden;\n  }\n  th,\n  td {\n    border: none;\n    color: #000;\n    padding: 16px;\n    min-width: 100px;\n    font-family: \"Raleway\";\n    vertical-align: middle;\n  }\n  th {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid #e0e0e0;\n  }\n  td {\n    border-bottom: 1px solid #e0e0e0;\n  }\n  td[scope=\"row\"] {\n    position: relative;\n  }\n  .inner {\n    width: 100%;\n    margin-bottom: 0px;\n    td {\n      padding: 5px;\n      border: 0px;\n      &:first-child {\n        width: 30px;\n      }\n    }\n  }\n  tbody tr {\n    cursor: pointer;\n    transition: background-color 0.2s;\n    &:first-child {\n      // display: flex;\n    }\n    &:hover {\n      background-color: #f9f9f9;\n      td {\n        color: #000;\n      }\n    }\n    &:last-child td {\n      border-bottom: none;\n    }\n    span {\n      display: flex;\n      align-items: center;\n    }\n  }\n  // tr:nth-child(even){\n  //     background: #5ea1d8;\n\n  // }\n  // tr:nth-child(even) td{\n  //     color: #fff;\n  // }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0px;\n    border: 1px solid #ddd;\n    border-bottom: 0px;\n    padding: 10px 10px;\n    // position: fixed;\n    // width:calc(100% - 250px);\n  }\n  .filter-title {\n    flex: 1;\n  }\n  .filter ul {\n    display: flex;\n    float: right;\n  }\n  .filter-bar {\n    display: flex;\n    width: 100%;\n  }\n  .filter-ico {\n    flex: 1;\n  }\n  .search-container {\n    position: relative;\n  }\n\n  .search-input {\n    width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    position: relative;\n  }\n  .search-input + i {\n    position: absolute;\n    right: 20px;\n    top: 37%;\n  }\n\n  .search-icon {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n  }\n\n  .chekbox-image {\n    display: flex;\n    td {\n      &:first-child {\n        width: unset;\n        flex: 1;\n        min-width: 150px;\n        display: flex;\n        align-items: flex-start;\n        span {\n          padding-left: 13px;\n        }\n      }\n      &:last-child {\n        min-width: unset;\n        width: 40px;\n        display: flex;\n        align-items: flex-start;\n      }\n    }\n  }\n  .image-sec {\n    img {\n      max-width: 100%;\n      max-height: 80px;\n      // width: 100%;\n      object-fit: cover;\n    }\n  }\n  .bundel {\n    span {\n      img {\n      }\n    }\n  }\n  .mobile-design {\n    display: none;\n  }\n}\n@media (max-width: 992px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      .box {\n        margin: 10px;\n        width: 100%;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 15px;\n      &:after {\n        height: 130px;\n      }\n    }\n    .filter {\n      // display: none;\n    }\n    .search-container {\n      .search-input {\n        width: 100%;\n      }\n    }\n    .top-menu-wrap {\n      display: none;\n    }\n    .table-wrap {\n      top: unset;\n      .table-parent {\n        display: none;\n      }\n    }\n    .mobile-design {\n      padding: 20px 10px;\n      background: lightblue;\n      display: block;\n      .tile {\n        background: #fff;\n        padding: 10px;\n        & > div {\n          border-bottom: 1px solid #ddd;\n        }\n        p {\n          color: #5ea1d8 !important;\n        }\n        p.bold {\n          font-weight: 700 !important;\n          font-family: Arial, Helvetica, sans-serif !important;\n        }\n        .main-title {\n          display: flex;\n          align-items: center;\n          background: #5ea1d8;\n          padding: 10px;\n          margin-bottom: 10px;\n          h3 {\n            margin-bottom: 0px !important;\n            color: #fff !important;\n          }\n        }\n      }\n      .first-tile {\n        div {\n          display: flex;\n          align-items: center;\n          margin-bottom: 10px;\n          span {\n            display: flex;\n            align-items: center;\n          }\n        }\n\n        input {\n          position: relative;\n          margin: 0px 10px 0px 0px;\n          width: 20px;\n          height: 20px;\n        }\n        .img {\n          display: flex;\n          align-items: flex-start;\n          .bundle {\n            width: 30px;\n            margin-right: 10px;\n            height: 30px;\n          }\n          img {\n            width: 100%;\n            max-height: 80px;\n            object-fit: cover;\n          }\n        }\n      }\n      .common-tile {\n        display: flex;\n        .title-tile {\n          flex: 1;\n          padding: 3px;\n        }\n      }\n    }\n  }\n}\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  height: 13vh;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    height: 100vh;\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  padding-left: 10px;\n  margin-top: 0; /* remove global top gap under header */\n}\n\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n/* In your component CSS */\nli.active {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  top: var(--app-header); /* align to global header height */\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* align just below app header - match landing page */\n  margin-top: 0 !important; /* avoid extra collapse/push inside components */\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 10px 15px 0; /* match landing page padding */\n  }\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n.setting-dashboard .show-menu .left-user {\n  left: 0px;\n  transition: left 0.5s linear;\n}\n\n/*panel collapse */\n\n.toggle-settings-class {\n  .left-user {\n    width: 80px;\n\n    // transition: all 0.5s linear;\n    .dash-title {\n      font-size: 0px;\n\n      h6 {\n        span {\n          margin-right: 0px;\n\n          &:last-child {\n            display: none;\n          }\n        }\n      }\n    }\n\n    .search {\n      input {\n        display: none;\n      }\n\n      i {\n        color: #fff;\n      }\n    }\n\n    .dash-elemenet {\n      div {\n        span {\n          &:last-child {\n            display: none;\n          }\n        }\n\n        // font-size: 0px;\n      }\n    }\n  }\n\n  .submission-field {\n    left: 80px;\n    width: calc(100% - 80px);\n    .hamburger {\n      .dash-title {\n        left: 80px;\n        width: calc(100% - 80px);\n      }\n    }\n  }\n\n  .collapse-btn {\n    transform: none !important;\n  }\n\n  .pagination-wrap {\n    left: 80px;\n    width: calc(100% - 80px);\n  }\n\n  .graybg {\n    display: block;\n\n    div {\n      white-space: nowrap;\n      // overflow: hidden;\n      padding: 0px 5px 0px 8px !important;\n\n      span {\n        overflow: hidden;\n        display: block !important;\n        margin-right: 0px !important;\n        letter-spacing: 15px;\n\n        &::first-letter {\n          display: block;\n          white-space: nowrap;\n          font-size: 20px;\n        }\n      }\n    }\n  }\n}\n\n// .mat-expansion-panel-header.mat-expanded{\n//   background: #6322b2 !important;\n//   }\n.toggle-settings-class {\n  .pagination-wrap {\n    width: calc(100% - 80px) !important;\n  }\n}\n/* ===========================================\n   MOBILE MENU - MATCHES DESKTOP MENU STYLING\n   =========================================== */\n@media (max-width: 767px) {\n  /* Hamburger button */\n  .mob-menu {\n    background: #5d9fd5;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1999;\n    width: 100%;\n    display: block;\n  }\n\n  /* Hide hamburger button when menu is open */\n  .setting-dashboard.show-menu .mob-menu {\n    display: none !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n    z-index: 1 !important;\n  }\n\n  .navbar {\n    justify-content: flex-end;\n    margin-bottom: 0;\n    padding: 0;\n  }\n\n  .mob-menu button {\n    background: #5d9fd5;\n    color: #fff;\n    font-size: 14px;\n    padding: 12px 20px;\n    border: 1px solid #fff;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n    margin-right: 15px;\n    cursor: pointer;\n  }\n\n  /* Mobile Menu Overlay */\n  .setting-dashboard.show-menu::after {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    z-index: 1998;\n    display: block;\n  }\n\n  /* Override mob-hide to show menu when opened */\n  .setting-dashboard.show-menu .mob-hide .left-user {\n    display: block !important;\n  }\n\n  /* Mobile Menu Panel - Slides from right, same structure as desktop */\n  .setting-dashboard .left-user {\n    position: fixed !important;\n    top: 0;\n    left: auto !important;\n    right: -100%;\n    width: 280px;\n    max-width: 85vw;\n    height: 100vh;\n    background: #5ea1d8;\n    z-index: 2001 !important;\n    transition: right 0.3s ease-in-out;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0 0 0 30px;\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .setting-dashboard.show-menu .left-user {\n    left: auto !important;\n    right: 0 !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    z-index: 2001 !important;\n  }\n\n  /* Show desktop title in mobile (same as desktop) */\n  .setting-dashboard .left-user .dash-title {\n    display: flex;\n    position: relative;\n    width: 100%;\n    height: 80px;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    top: 0;\n    z-index: 2;\n  }\n\n  .setting-dashboard .left-user .collapse-btn {\n    display: none;\n  }\n\n  /* Menu Content Container - Same as desktop */\n  .setting-dashboard .left-user .dash-elemenet {\n    display: flex !important;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: column;\n    margin-top: 1rem;\n    height: calc(100vh - 220px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-right: 20px;\n    width: 100%;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  /* Menu List Container - Same as desktop */\n  .setting-dashboard .left-user .detail-list {\n    display: block !important;\n    width: 100%;\n    max-width: 250px;\n    padding: 20px 10px;\n    background-color: transparent;\n    position: relative;\n    height: auto;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  /* Menu List - Same as desktop */\n  .setting-dashboard .left-user ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  /* Menu List Items - Same styling as desktop */\n  .setting-dashboard .left-user ul li {\n    height: 40px;\n    margin-bottom: 10px;\n    position: relative;\n    display: flex !important;\n    align-items: center;\n    transition: all 0.5s linear;\n    padding-left: 10px;\n    color: #fff !important;\n    font-size: 13px;\n    font-weight: 400;\n    cursor: pointer;\n    background: transparent;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  /* Hover effect - Same as desktop */\n  .setting-dashboard .left-user ul li:after {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0%;\n    position: absolute;\n    background: #1d67a3;\n    transition: all 0.5s linear;\n    width: 0;\n    z-index: -1;\n  }\n\n  .setting-dashboard .left-user ul li:hover:after,\n  .setting-dashboard .left-user ul li:active:after,\n  .setting-dashboard .left-user ul li:focus:after {\n    content: \"\";\n    width: 100%;\n    left: 0;\n    transition: all 0.5s linear;\n  }\n\n  /* Active state - Same as desktop */\n  .setting-dashboard .left-user ul li.active {\n    background: #1d67a3 !important;\n    color: #fff !important;\n    padding-left: 10px;\n  }\n\n  .setting-dashboard .left-user ul li.active:after {\n    width: 100%;\n  }\n\n  /* Content Area Adjustments */\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0;\n    position: relative;\n  }\n\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    position: relative;\n    top: 0;\n    height: auto;\n    padding: 15px;\n  }\n\n  /* Ensure router-outlet content doesn't interfere with menu */\n  router-outlet {\n    display: block;\n    width: 100%;\n  }\n\n  /* Ensure menu works on all child pages */\n  .setting-dashboard router-outlet ~ *,\n  .setting-dashboard router-outlet + * {\n    position: relative;\n    z-index: 1;\n  }\n\n  /* When menu is open, ensure child page content is behind menu */\n  .setting-dashboard.show-menu router-outlet ~ *,\n  .setting-dashboard.show-menu router-outlet + * {\n    z-index: 1;\n  }\n\n  /* Remove all padding and margin from child pages on mobile */\n  router-outlet ~ *,\n  router-outlet + * {\n    padding: 0 !important;\n    margin: 0 !important;\n    \n    * {\n      margin-top: 0 !important;\n    }\n    \n    .dashbored-wrap {\n      margin-top: 10px !important;\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n    \n    .scroll-div {\n      margin-top: 0 !important;\n      padding-top: 0 !important;\n      padding: 0 !important;\n      margin: 0 !important;\n      top: 0 !important;\n    }\n    \n    .com-record {\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n    \n    .table-wrap {\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n    \n    .mobile-design {\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n    \n    .detail-description {\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n    \n    .hamburger {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n    \n    .submission-field {\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n  }\n  \n  /* Specifically target scroll-div in all user-dashboard child pages on mobile */\n  app-dashboard .scroll-div,\n  app-content-analytics .scroll-div,\n  app-giftedfunds .scroll-div,\n  app-consultations .scroll-div,\n  app-scheduleconsultations .scroll-div,\n  app-access-requests .scroll-div,\n  app-transfered-content-approvals .scroll-div,\n  app-outgoing-approvals .scroll-div,\n  app-incoming-approvals .scroll-div,\n  app-content-approvals .scroll-div,\n  app-flow-reviews .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n\n  .dashbored-wrap .table-wrap {\n    padding: 0;\n  }\n\n  .dashbored-wrap .mobile-design {\n    padding: 20px; /* match landing page mobile padding */\n  }\n\n  .dashbored-wrap .com-record:after {\n    height: 133px;\n  }\n}\n\n// ===========================================\n// COMPREHENSIVE RESPONSIVE DESIGN SYSTEM\n// ===========================================\n\n// Extra Large Desktop (1920px+)\n@media (min-width: $desktop-xl) {\n  .dashbored-wrap {\n    .detail-list {\n      max-width: 300px;\n      padding: 30px 20px;\n    }\n    .detail-description {\n      margin-left: 320px;\n      padding: 30px;\n    }\n    .followers-tag {\n      .box {\n        padding: 25px;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n// Large Desktop (1440px - 1919px)\n@media (min-width: $desktop-large) and (max-width: $desktop-xl) {\n  .dashbored-wrap {\n    .detail-list {\n      max-width: 280px;\n      padding: 25px 15px;\n    }\n    .detail-description {\n      margin-left: 300px;\n      padding: 25px;\n    }\n  }\n}\n\n// Desktop (1200px - 1439px)\n@media (min-width: $desktop) and (max-width: $desktop-large) {\n  .dashbored-wrap {\n    .detail-list {\n      max-width: 250px;\n    }\n    .detail-description {\n      margin-left: 270px;\n    }\n  }\n}\n\n// Large Tablet (1024px - 1199px)\n@media (min-width: $tablet-large) and (max-width: $desktop) {\n  .dashbored-wrap {\n    .detail-list {\n      max-width: 220px;\n      padding: 15px 10px;\n    }\n    .detail-description {\n      margin-left: 240px;\n      padding: 20px;\n    }\n    .followers-tag {\n      .box {\n        width: calc(50% - 10px);\n        min-width: 200px;\n      }\n    }\n  }\n\n  // Tablet (768px - 1023px)\n  @media (min-width: $tablet) and (max-width: $tablet-large) {\n    .dashbored-wrap {\n      .detail-list {\n        display: none;\n      }\n      .detail-description {\n        width: 100%;\n        margin-left: 0;\n        padding: 20px;\n      }\n      .followers-tag {\n        flex-wrap: wrap;\n        gap: 15px;\n        .box {\n          width: calc(50% - 7.5px);\n          min-width: 200px;\n          padding: 15px;\n        }\n      }\n      .top-menu-wrap {\n        padding: 15px 10px;\n        flex-wrap: wrap;\n        gap: 10px;\n      }\n      .user-details {\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 10px;\n      }\n    }\n  }\n\n  // Mobile Large (481px - 767px)\n  @media (min-width: $mobile) and (max-width: $tablet) {\n    .dashbored-wrap {\n      .detail-list {\n        display: none;\n      }\n      .detail-description {\n        width: 100%;\n        margin-left: 0;\n        padding: 15px;\n      }\n      .followers-tag {\n        flex-direction: column;\n        gap: 12px;\n        .box {\n          width: 100%;\n          min-width: unset;\n          padding: 12px;\n          .text {\n            font-size: 14px;\n          }\n        }\n      }\n      .top-menu-wrap {\n        padding: 10px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n        height: auto;\n        min-height: 80px;\n      }\n      .user-details {\n        width: 100%;\n        justify-content: space-between;\n        flex-direction: row;\n      }\n      .hamburger {\n        display: block;\n        .dash-title h6 {\n          font-size: 16px;\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  // Mobile (320px - 480px)\n  @media (max-width: $mobile) {\n    .dashbored-wrap {\n      .detail-list {\n        display: none;\n      }\n      .detail-description {\n        width: 100%;\n        margin-left: 0;\n        padding: 10px;\n      }\n      .followers-tag {\n        flex-direction: column;\n        gap: 10px;\n        .box {\n          width: 100%;\n          min-width: unset;\n          padding: 10px;\n          .text {\n            font-size: 13px;\n          }\n          .icon {\n            .ico-box {\n              width: 30px;\n              height: 30px;\n              font-size: 16px;\n            }\n          }\n        }\n      }\n      .top-menu-wrap {\n        padding: 8px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        height: auto;\n        min-height: 70px;\n      }\n      .user-details {\n        width: 100%;\n        justify-content: space-between;\n        flex-direction: row;\n        .user-name {\n          p {\n            font-size: 14px;\n          }\n          span {\n            width: 30px;\n            height: 30px;\n          }\n        }\n      }\n      .hamburger {\n        display: block;\n        .dash-title h6 {\n          font-size: 14px;\n          margin: 0;\n          display: flex;\n          align-items: center;\n          gap: 5px;\n          .material-icons {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile Small (320px and below)\n  @media (max-width: $mobile-small) {\n    .dashbored-wrap {\n      .detail-description {\n        padding: 8px;\n      }\n      .followers-tag {\n        gap: 8px;\n        .box {\n          padding: 8px;\n          .text {\n            font-size: 12px;\n          }\n          .icon {\n            .ico-box {\n              width: 25px;\n              height: 25px;\n              font-size: 14px;\n            }\n          }\n        }\n      }\n      .top-menu-wrap {\n        padding: 5px;\n        min-height: 60px;\n      }\n      .hamburger {\n        .dash-title h6 {\n          font-size: 12px;\n          .material-icons {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  // ===========================================\n  // RESPONSIVE NAVIGATION MENU\n  // ===========================================\n\n  // Mobile menu toggle\n  @media (max-width: $tablet) {\n    .detail-list {\n      position: fixed;\n      top: 0;\n      left: -100%;\n      width: 80%;\n      max-width: 300px;\n      height: 100vh;\n      background: #efeeee;\n      z-index: 1000;\n      transition: left 0.3s ease;\n      padding-top: calc(var(--app-header) + 5px);\n\n      &.mobile-open {\n        left: 0;\n      }\n    }\n\n    .mobile-menu-overlay {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: rgba(0, 0, 0, 0.5);\n      z-index: 999;\n      display: none;\n\n      &.active {\n        display: block;\n      }\n    }\n  }\n\n  // ===========================================\n  // RESPONSIVE TYPOGRAPHY\n  // ===========================================\n\n  @media (max-width: $mobile) {\n    h1 {\n      font-size: 24px;\n    }\n    h2 {\n      font-size: 20px;\n    }\n    h3 {\n      font-size: 18px;\n    }\n    h4 {\n      font-size: 16px;\n    }\n    h5 {\n      font-size: 14px;\n    }\n    h6 {\n      font-size: 12px;\n    }\n    p {\n      font-size: 14px;\n    }\n  }\n\n  @media (max-width: $mobile-small) {\n    h1 {\n      font-size: 20px;\n    }\n    h2 {\n      font-size: 18px;\n    }\n    h3 {\n      font-size: 16px;\n    }\n    h4 {\n      font-size: 14px;\n    }\n    h5 {\n      font-size: 12px;\n    }\n    h6 {\n      font-size: 11px;\n    }\n    p {\n      font-size: 12px;\n    }\n  }\n}\n\n// ===========================================\n// MOBILE TRANSLATE LANGUAGE LOADER - FOOTER POSITION\n// ===========================================\n@media (max-width: 767px) {\n  // Move Google Translate banner frame to footer on mobile\n  .goog-te-banner-frame {\n    position: fixed !important;\n    bottom: 0 !important; // Position at footer\n    top: auto !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1001 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 60px !important;\n    max-height: 300px !important;\n    margin-bottom: 0 !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    display: block !important;\n  }\n\n  // Move Google Translate iframe to footer on mobile\n  iframe.skiptranslate,\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  iframe[class*=\"skiptranslate\"],\n  iframe[id*=\"container\"] {\n    position: fixed !important;\n    bottom: 0 !important; // Position at footer\n    top: auto !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1001 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 60px !important;\n    max-height: 300px !important;\n    margin-bottom: 0 !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    display: block !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n  }\n\n  // Style the banner content at footer\n  .goog-te-banner-frame skipptr {\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 16px !important;\n    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;\n    min-height: 60px !important;\n    max-height: 300px !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  // Ensure banner frame content is scrollable\n  .goog-te-banner-frame {\n    & > * {\n      max-height: 100% !important;\n      overflow-y: auto !important;\n    }\n  }\n}\n\n/* Dark mode foundation for dashboard + child routes */\n:host-context(body.theme-dark) {\n  // Main wrapper – dark background\n  .setting-dashboard,\n  .setting-dashboard .container1,\n  .setting-dashboard .commonclass {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n  }\n\n  // Left sidebar – distinct dark panel so items are visible\n  .setting-dashboard .left-user {\n    background: #0d1b2e !important;\n    border-right: 1px solid rgba(94, 161, 216, 0.3) !important;\n  }\n\n  // Sidebar header title\n  .setting-dashboard .dash-title {\n    background: #0d1b2e !important;\n    border-bottom: 1px solid rgba(94, 161, 216, 0.2) !important;\n    color: #e5e7eb !important;\n  }\n\n  // List separators inside sidebar\n  .setting-dashboard .detail-list {\n    background: transparent !important;\n  }\n\n  // Content panel border separator\n  .setting-dashboard .submission-field {\n    border-left: 1px solid rgba(94, 161, 216, 0.3) !important;\n  }\n\n  // Sidebar nav items\n  .setting-dashboard ul li {\n    color: #94a3b8 !important;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.08) !important;\n  }\n\n  .setting-dashboard ul li:hover {\n    background: rgba(94, 161, 216, 0.15) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .setting-dashboard ul li.active {\n    background: rgba(94, 161, 216, 0.25) !important;\n    color: #ffffff !important;\n    border-left: 3px solid #5ea1d8 !important;\n  }\n\n  .setting-dashboard ul li:before {\n    background: rgba(94, 161, 216, 0.2) !important;\n  }\n\n  // Dash elements (icon + label rows) – colour only, no hover here (div wraps all li's)\n  .setting-dashboard .dash-elemenet > div {\n    color: #94a3b8 !important;\n  }\n\n  // Active / selected item highlight\n  .setting-dashboard .left-user .selected-item {\n    background: rgba(94, 161, 216, 0.25) !important;\n    color: #ffffff !important;\n  }\n\n  .setting-dashboard .dash-title h6,\n  .setting-dashboard .dash-title .h6 {\n    color: #5ea1d8 !important;\n  }\n\n  .setting-dashboard .dash-title span {\n    color: #5ea1d8 !important;\n  }\n\n  .setting-dashboard .navbar-toggler {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #e5e7eb !important;\n  }\n\n  /* Child routes rendered via router-outlet */\n  ::ng-deep .dashbored-wrap,\n  ::ng-deep .dashbored-wrap .detail-list,\n  ::ng-deep .dashbored-wrap .com-record,\n  ::ng-deep .dashbored-wrap .table-wrap,\n  ::ng-deep .dashbored-wrap .box,\n  ::ng-deep .dashbored-wrap .filter,\n  ::ng-deep .dashbored-wrap .tab-content,\n  ::ng-deep .dashbored-wrap .card,\n  ::ng-deep .dashbored-wrap .mat-mdc-card {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    box-shadow: none !important;\n  }\n\n  ::ng-deep .dashbored-wrap p,\n  ::ng-deep .dashbored-wrap span,\n  ::ng-deep .dashbored-wrap label,\n  ::ng-deep .dashbored-wrap li,\n  ::ng-deep .dashbored-wrap td,\n  ::ng-deep .dashbored-wrap th,\n  ::ng-deep .dashbored-wrap h1,\n  ::ng-deep .dashbored-wrap h2,\n  ::ng-deep .dashbored-wrap h3,\n  ::ng-deep .dashbored-wrap h4,\n  ::ng-deep .dashbored-wrap h5,\n  ::ng-deep .dashbored-wrap h6 {\n    color: #e5e7eb !important;\n  }\n\n  ::ng-deep .dashbored-wrap table,\n  ::ng-deep .dashbored-wrap thead,\n  ::ng-deep .dashbored-wrap tbody,\n  ::ng-deep .dashbored-wrap tr,\n  ::ng-deep .dashbored-wrap td,\n  ::ng-deep .dashbored-wrap th {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  ::ng-deep .dashbored-wrap tbody tr:hover {\n    background: #1f2937 !important;\n  }\n}\n\n/* Dark mode polish: stronger contrast + no white surfaces */\n:host-context(body.theme-dark) {\n  .dashbored-wrap,\n  .dashbored-wrap .top-menu-wrap,\n  .dashbored-wrap .detail-description,\n  .dashbored-wrap .table-wrap,\n  .dashbored-wrap .com-record,\n  .dashbored-wrap .mobile-design,\n  .dashbored-wrap .tile,\n  .dashbored-wrap .box,\n  .dashbored-wrap .filter,\n  .dashbored-wrap .search-input,\n  .dashbored-wrap .detail-list {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dashbored-wrap p,\n  .dashbored-wrap span,\n  .dashbored-wrap label,\n  .dashbored-wrap li,\n  .dashbored-wrap td,\n  .dashbored-wrap th,\n  .dashbored-wrap h1,\n  .dashbored-wrap h2,\n  .dashbored-wrap h3,\n  .dashbored-wrap h4,\n  .dashbored-wrap h5,\n  .dashbored-wrap h6,\n  .dashbored-wrap i {\n    color: #ffffff !important;\n  }\n\n  .dashbored-wrap table,\n  .dashbored-wrap thead,\n  .dashbored-wrap tbody,\n  .dashbored-wrap tr,\n  .dashbored-wrap td,\n  .dashbored-wrap th {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dashbored-wrap tbody tr:hover {\n    background: #1f2937 !important;\n  }\n\n  .dashbored-wrap [style*=\"background: white\"],\n  .dashbored-wrap [style*=\"background:white\"],\n  .dashbored-wrap [style*=\"background-color: white\"],\n  .dashbored-wrap [style*=\"background-color:white\"],\n  .dashbored-wrap [style*=\"background: #fff\"],\n  .dashbored-wrap [style*=\"background:#fff\"],\n  .dashbored-wrap [style*=\"background: #ffffff\"],\n  .dashbored-wrap [style*=\"background:#ffffff\"],\n  .dashbored-wrap [style*=\"background-color: #fff\"],\n  .dashbored-wrap [style*=\"background-color:#fff\"],\n  .dashbored-wrap [style*=\"background-color: #ffffff\"],\n  .dashbored-wrap [style*=\"background-color:#ffffff\"],\n  .dashbored-wrap [style*=\"background: rgb(255, 255, 255)\"],\n  .dashbored-wrap [style*=\"background:rgb(255,255,255)\"],\n  .dashbored-wrap [style*=\"background-color: rgb(255, 255, 255)\"],\n  .dashbored-wrap [style*=\"background-color:rgb(255,255,255)\"],\n  .dashbored-wrap [style*=\"background: var(--white)\"],\n  .dashbored-wrap [style*=\"background-color: var(--white)\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  /* Hardening: catch routed child content outside dashbored-wrap */\n  .setting-dashboard router-outlet ~ *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]),\n  .setting-dashboard router-outlet + *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]),\n  .setting-dashboard .submission-field > *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]),\n  .setting-dashboard .submission-field > * *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]),\n  .setting-dashboard .detail-description,\n  .setting-dashboard .detail-description *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]),\n  .setting-dashboard .scroll-div,\n  .setting-dashboard .scroll-div *:not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-reason-cell\"]):not([class*=\"consult-card\"]):not([class*=\"consult-profile\"]) {\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .setting-dashboard router-outlet ~ *[style*=\"background\"],\n  .setting-dashboard router-outlet + *[style*=\"background\"],\n  .setting-dashboard .submission-field *[style*=\"background\"],\n  .setting-dashboard .detail-description *[style*=\"background\"],\n  .setting-dashboard .scroll-div *[style*=\"background\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n  }\n\n  .setting-dashboard .mat-mdc-card,\n  .setting-dashboard .mat-card,\n  .setting-dashboard .mat-expansion-panel,\n  .setting-dashboard .mat-mdc-tab-body-content,\n  .setting-dashboard .mat-mdc-tab-body,\n  .setting-dashboard .mat-mdc-tab-body-wrapper,\n  .setting-dashboard .table,\n  .setting-dashboard table,\n  .setting-dashboard tbody,\n  .setting-dashboard tr,\n  .setting-dashboard td {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Title/header bars: remove white patches */\n  .setting-dashboard .dash-title,\n  .setting-dashboard .submission-field .hamburger .dash-title,\n  .setting-dashboard .left-user .dash-title,\n  .page-section-header,\n  .page-section-title {\n    background: transparent !important;\n    background-color: transparent !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Title card container (child pages) */\n  ::ng-deep .setting-dashboard .dash-text,\n  ::ng-deep .setting-dashboard .dash-text > div,\n  ::ng-deep .setting-dashboard .main-title,\n  ::ng-deep .setting-dashboard .title-tile,\n  ::ng-deep .setting-dashboard .page-section-header,\n  ::ng-deep .setting-dashboard .page-header,\n  ::ng-deep .setting-dashboard .header-section {\n    background: transparent !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    color: #ffffff !important;\n  }\n\n  /* ── CSS-variable-driven table cells (child routes) ── */\n  ::ng-deep table,\n  ::ng-deep thead,\n  ::ng-deep tbody,\n  ::ng-deep tr,\n  ::ng-deep td {\n    background: var(--fc-bg) !important;\n    color: var(--fc-fg) !important;\n    border-color: var(--fc-border) !important;\n  }\n\n  ::ng-deep th {\n    background: var(--fc-bg-head) !important;\n    color: var(--fc-fg) !important;\n    border-color: var(--fc-border) !important;\n  }\n\n  ::ng-deep tbody tr:hover {\n    background: var(--fc-bg-hover) !important;\n  }\n\n  /* No-data rows should also be dark */\n  ::ng-deep tr.no-data-row,\n  ::ng-deep tr.no-data-row:hover {\n    background: var(--fc-bg) !important;\n    td { color: var(--fc-fg) !important; }\n  }\n\n  /* Cards / boxes in child routes */\n  ::ng-deep .box,\n  ::ng-deep .tile,\n  ::ng-deep .card,\n  ::ng-deep .stats-cards .box {\n    background: var(--fc-bg2) !important;\n    border-color: var(--fc-border) !important;\n    color: var(--fc-fg) !important;\n  }\n\n  /* Skeleton loaders */\n  ::ng-deep .skeleton-box,\n  ::ng-deep .skeleton-tile,\n  ::ng-deep .skeleton-table-container,\n  ::ng-deep .skeleton-mobile-container {\n    background: var(--fc-skel) !important;\n    table, thead, th, td, tr { background: var(--fc-skel) !important; }\n  }\n\n  ::ng-deep .skeleton-text,\n  ::ng-deep .skeleton-bold,\n  ::ng-deep .skeleton-count,\n  ::ng-deep .skeleton-checkbox,\n  ::ng-deep .skeleton-icon,\n  ::ng-deep .skeleton-image,\n  ::ng-deep .skeleton-price {\n    background: linear-gradient(\n      90deg,\n      var(--fc-skel) 25%,\n      var(--fc-skel-wave) 50%,\n      var(--fc-skel) 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  /* Mobile tile cards inside dashbored-wrap */\n  ::ng-deep .mobile-design,\n  ::ng-deep .mobile-design .tile {\n    background: var(--fc-bg) !important;\n    border-color: var(--fc-border) !important;\n  }\n\n  /* Text / label colour inside child routes */\n  ::ng-deep p:not([class*=\"consult-card\"]), ::ng-deep span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]):not([class*=\"consult-\"]), ::ng-deep label,\n  ::ng-deep li, ::ng-deep h1, ::ng-deep h2, ::ng-deep h3,\n  ::ng-deep h4, ::ng-deep h5, ::ng-deep h6, ::ng-deep b, ::ng-deep i {\n    color: var(--fc-fg) !important;\n  }\n\n  /* Consultation description / reason cell text — explicit colours to prevent override */\n  ::ng-deep .consult-reason-cell__flow   { color: #f1f5f9 !important; }\n  ::ng-deep .consult-reason-cell__reason { color: #cbd5e1 !important; }\n  ::ng-deep .consult-reason-cell__empty  { color: #64748b !important; }\n  ::ng-deep .consult-card-reason         { color: #cbd5e1 !important; }\n  ::ng-deep .consult-card-flow-title     { color: #f1f5f9 !important; }\n  ::ng-deep .consult-profile-link        { color: #93c5fd !important; background: none !important; }\n\n  /* Badge dark mode colours — these ::ng-deep rules re-apply colours that the\n     generic span rule above would otherwise overwrite in child routes */\n  ::ng-deep .status-badge-modern.status-completed {\n    background-color: #052e16 !important;\n    color: #86efac !important;\n  }\n  ::ng-deep .status-badge-modern.status-scheduled {\n    background-color: #1e3a5f !important;\n    color: #93c5fd !important;\n  }\n  ::ng-deep .status-badge-modern.status-rescheduled {\n    background-color: #2e1065 !important;\n    color: #c4b5fd !important;\n  }\n  ::ng-deep .status-badge-modern.status-canceled,\n  ::ng-deep .status-badge-modern.status-cancelled,\n  ::ng-deep .status-badge-modern.status-did-not-happen {\n    background-color: #450a0a !important;\n    color: #fca5a5 !important;\n  }\n  ::ng-deep .status-badge-modern.status-pending {\n    background-color: #451a03 !important;\n    color: #fcd34d !important;\n  }\n  ::ng-deep .status-badge-modern.status-approved {\n    background-color: #052e16 !important;\n    color: #86efac !important;\n  }\n  ::ng-deep .status-badge-modern.status-rejected {\n    background-color: #450a0a !important;\n    color: #fca5a5 !important;\n  }\n  ::ng-deep .status-badge-modern.status-reworkrequested {\n    background-color: #451a03 !important;\n    color: #fcd34d !important;\n  }\n  ::ng-deep .status-badge-modern.status-cancelled {\n    background-color: #1f2937 !important;\n    color: #9ca3af !important;\n  }\n  ::ng-deep .status-badge-modern.completed {\n    background-color: #052e16 !important;\n    color: #86efac !important;\n  }\n  ::ng-deep .status-badge-modern.failed {\n    background-color: #450a0a !important;\n    color: #fca5a5 !important;\n  }\n  ::ng-deep .badge.badge-success {\n    background: #052e16 !important;\n    color: #86efac !important;\n  }\n  ::ng-deep .badge.badge-danger {\n    background: #450a0a !important;\n    color: #fca5a5 !important;\n  }\n  ::ng-deep .badge.badge-secondary {\n    background: #1f2937 !important;\n    color: #9ca3af !important;\n  }\n  ::ng-deep .badge.badge-warning {\n    background: #451a03 !important;\n    color: #fcd34d !important;\n  }\n  ::ng-deep .badge.badge-info {\n    background: #0c3443 !important;\n    color: #67e8f9 !important;\n  }\n  ::ng-deep .status-badge.status-pending,\n  ::ng-deep .status-badge.status-reworkrequested {\n    background: #451a03 !important;\n    color: #fcd34d !important;\n  }\n  ::ng-deep .status-badge.status-approved {\n    background: #052e16 !important;\n    color: #86efac !important;\n  }\n  ::ng-deep .status-badge.status-rejected {\n    background: #450a0a !important;\n    color: #fca5a5 !important;\n  }\n  ::ng-deep .status-badge.status-cancelled {\n    background: #1f2937 !important;\n    color: #9ca3af !important;\n  }\n}\n\n// ══════════════════════════════════════════════════════════\n// DIRECT body.theme-dark rules – guaranteed to apply because\n// these compile as: body.theme-dark .class[_ngcontent-xxx]\n// which does NOT require the unreliable [_nghost] trick.\n// ══════════════════════════════════════════════════════════\nbody.theme-dark .setting-dashboard {\n  background: #111827 !important;\n}\n\n// Left sidebar – dark navy panel, distinct from main bg\nbody.theme-dark .setting-dashboard .left-user {\n  background: #0d1b2e !important;\n  border-right: 1px solid rgba(94, 161, 216, 0.3) !important;\n}\n\nbody.theme-dark .setting-dashboard .dash-title {\n  background: #0d1b2e !important;\n  border-bottom: 1px solid rgba(94, 161, 216, 0.2) !important;\n}\n\nbody.theme-dark .setting-dashboard .dash-title h6,\nbody.theme-dark .setting-dashboard .dash-title .h6 {\n  color: #5ea1d8 !important;\n}\n\nbody.theme-dark .setting-dashboard .dash-title span {\n  color: #5ea1d8 !important;\n}\n\n// Sidebar nav items\nbody.theme-dark .setting-dashboard ul li {\n  color: #94a3b8 !important;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.08) !important;\n}\n\nbody.theme-dark .setting-dashboard ul li:hover {\n  background: rgba(94, 161, 216, 0.15) !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .setting-dashboard ul li.active {\n  background: rgba(94, 161, 216, 0.25) !important;\n  color: #ffffff !important;\n  border-left: 3px solid #5ea1d8 !important;\n}\n\nbody.theme-dark .setting-dashboard .left-user .selected-item {\n  background: rgba(94, 161, 216, 0.25) !important;\n  color: #ffffff !important;\n}\n\nbody.theme-dark .setting-dashboard .dash-elemenet > div {\n  color: #94a3b8 !important;\n}\n\n// Content area separator line\nbody.theme-dark .setting-dashboard .submission-field {\n  border-left: 1px solid rgba(94, 161, 216, 0.3) !important;\n}\n\n// Page section header inside content (the \"Creator Command Center\" line)\nbody.theme-dark .page-section-header {\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .page-section-title {\n  color: #e5e7eb !important;\n}\n\n/* ── Dark mode scrollbar + scroll container background fixes ── */\nbody.theme-dark .scroll-div {\n  background: #111827 !important;\n  background-color: #111827 !important;\n}\nbody.theme-dark .scroll-div::-webkit-scrollbar,\nbody.theme-dark .submission-field::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .scroll-div::-webkit-scrollbar-track,\nbody.theme-dark .submission-field::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .scroll-div::-webkit-scrollbar-thumb,\nbody.theme-dark .submission-field::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .scroll-div::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .submission-field::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .scroll-div::-webkit-scrollbar-corner,\nbody.theme-dark .submission-field::-webkit-scrollbar-corner {\n  background: #111827;\n}\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
